if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }

      // --- IMBODY customisation (re-apply this block after each theme update) ------------------------------------------------------------------------------------------------------
      // Days to stay quiet after the popup was merely seen, as opposed to the
      // longer `expiry` used once it has been actively dismissed.
      get seenExpiry() {
        return 7;
      }

      // Set on submit, read back after Shopify redirects, so that a newsletter
      // signup made in the footer does not reopen this popup.
      get pendingName() {
        return 'concept:newsletter-popup:pending';
      }

      // Subscribers are done with the popup for good. Kept in localStorage
      // because Safari caps script-written cookies at 7 days.
      get subscribed() {
        try {
          return localStorage.getItem(this.pendingName + '-done') === '1';
        } catch (e) {
          return false;
        }
      }

      setSubscribed() {
        try {
          localStorage.setItem(this.pendingName + '-done', '1');
        } catch (e) {}

        this.setCookie(this.cookieName, 400);
      }
      // --- end IMBODY customisation --- Below codes had been updated too ----------------------------------------------------------------------------------------------------
    
      init() {
        if (this.initialized) return;
        this.initialized = true;

        const fromPopup = this.getCookie(this.pendingName) !== null;
        if (fromPopup) this.removeCookie(this.pendingName);

        // Open modal if errors or success message exist
        if (this.submited) {
          if (this.querySelector('.alert--success')) this.setSubscribed();
          if (fromPopup) this.load(1);
          return;
        }

        if (this.subscribed && !this.testMode) return;

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.querySelector('form')?.addEventListener('submit', () => this.setCookie(this.pendingName, 1));
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      // Remember that it was seen before the opening transition runs, so that
      // ignoring it and navigating straight away still counts as seen
      beforeShow() {
        super.beforeShow();

        if (!this.testMode && !this.subscribed) this.setCookie(this.cookieName, this.seenExpiry);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          try { localStorage.removeItem(this.pendingName + '-done'); } catch (e) {}
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        // path must match the one used by setCookie, otherwise nothing is removed
        document.cookie = `${name}=; max-age=0; path=/`;
      }
    }
  );
}
